// src/pages/Integrations/IntegrationsPage.tsx
import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { motion } from "framer-motion";
import { Cable, Database, LineChart } from "lucide-react";

export default function IntegrationsPage() {
    return (
        <div className="container mx-auto px-6 py-20 space-y-12">
            <section className="text-center space-y-4">
                <motion.h1
                    initial={{ opacity: 0, y: 10 }}
                    animate={{ opacity: 1, y: 0 }}
                    className="text-4xl font-bold tracking-tight text-primary"
                >
                    Powerful Integrations
                </motion.h1>
                <p className="text-muted-foreground max-w-3xl mx-auto">
                    IDSCRM is built to connect. Whether it’s your existing DMS, finance partners,
                    marketing tools, or 3rd-party data providers — our ecosystem speaks your language.
                </p>
            </section>

            <section className="grid md:grid-cols-3 gap-6">
                <Card className="rounded-2xl">
                    <CardHeader className="flex items-center gap-2">
                        <Database className="h-5 w-5 text-primary" />
                        <CardTitle>Data Integrations</CardTitle>
                    </CardHeader>
                    <CardContent>
                        Sync with legacy systems like Frazer, DealerCenter, or your in-house DMS.
                        IDSCRM normalizes and cleanses data to keep your records accurate and live.
                    </CardContent>
                </Card>

                <Card className="rounded-2xl">
                    <CardHeader className="flex items-center gap-2">
                        <Cable className="h-5 w-5 text-primary" />
                        <CardTitle>API Connectivity</CardTitle>
                    </CardHeader>
                    <CardContent>
                        A modern RESTful API with secure token-based auth connects your web, mobile,
                        and partner applications in real time. Expand your ecosystem effortlessly.
                    </CardContent>
                </Card>

                <Card className="rounded-2xl">
                    <CardHeader className="flex items-center gap-2">
                        <LineChart className="h-5 w-5 text-primary" />
                        <CardTitle>Analytics & AI</CardTitle>
                    </CardHeader>
                    <CardContent>
                        Advanced analytics and AI modules help you forecast sales, optimize pricing,
                        and detect customer patterns — empowering smarter decisions daily.
                    </CardContent>
                </Card>
            </section>

            <div className="text-center pt-10">
                <p className="text-sm text-muted-foreground">
                    Future integrations: Manheim, Kelley Blue Book, Experian, CARFAX, and more.
                    IDSCRM is built to adapt — because your dealership never stops evolving.
                </p>
            </div>
        </div>
    );
}
